<template>
  <div>
    <input type="text" class="input-text" placeholder="Имя" v-model="name">
    <input type="text" class="input-text" placeholder="Email или телефон" v-model="contact">
    <vSelect v-model="city" :options="cities" :placeholder="'Выберите свой город'" :clearable="false"/>
    <div class="symptoms">
      <div class="symptoms-left">
        <Checkbox
          v-for="(symptom, i) of symptomsLeft"
          :key="i"
          :label="symptom.name"
          :value="symptom.value"
          v-model="symptom.value"
          name="symptoms[]"/>
      </div>
      <div class="symptoms-right">
        <Checkbox
          v-for="(symptom, i) of symptomsRight"
          :key="i"
          :label="symptom.name"
          :value="symptom.value"
          v-model="symptom.value"
          name="symptoms[]"/>
      </div>
    </div>
    <Error v-if="error" :text="error"/>
    <Button text="Отправить" @action="send" :disabled="name.length < 3 || contact.length < 5 || city == ''"/>
  </div>
</template>

<script>
  import Button from '@/components/Button.vue';
  import Checkbox from '@/components/Checkbox.vue';
  import Error from '@/components/Error.vue'
  import vSelect from "vue-select";

  export default {
    components: {
      Button,
      Error,
      vSelect,
      Checkbox
    },
    data() {
      return {
        error: ''
      }
    },
    computed: {
      cities() {
        let cities = this.$store.state.cities;
        return cities.map((element) => {
          return {label: `${element.title}, ${element.titleRegion}`, value: element.id}
        })
      },
      symptomsLeft: {
        set(val) {
          this.$store.state.symptomsLeft = val;
        },
        get() {
          return this.$store.state.symptomsLeft;
        }
      },
      symptomsRight: {
        set(val) {
          this.$store.state.symptomsLeft = val;
        },
        get() {
          return this.$store.state.symptomsRight;
        }
      },
      name: {
        set(val) {
          this.$store.state.symptomsContactsInfo.name = val;
        },
        get() {
          return this.$store.state.symptomsContactsInfo.name
        }
      },
      contact: {
        set(val) {
          this.$store.state.symptomsContactsInfo.contact = val;
        },
        get() {
          return this.$store.state.symptomsContactsInfo.contact
        }
      },
      city: {
        set(val) {
          this.$store.state.symptomsContactsInfo.city = val;
        },
        get() {
          return this.$store.state.symptomsContactsInfo.city
        }
      }
    },
    methods: {
      send() {
        const contact = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/.test(this.contact) ||
         /^((8|\+7)[ \- ]?)?(\(?\d{3}\)?[ \- ]?)?[\d\- ]{7,10}$/.test(this.contact);
         if (!contact) {
           this.error = 'Неправильно введен телефон или email';
           setTimeout(() => {
             this.error = '';
           }, 2000);
         } else {
           const symptomsLeftMap = this.symptomsLeft.filter(element => element.value == true).map(element => element.id)
           const symptomsRightMap = this.symptomsRight.filter(element => element.value == true).map(element => element.id)
           const symptoms = symptomsLeftMap.concat(symptomsRightMap)
           this.$store.dispatch('newUser', {
             firstname: this.name,
             login: this.contact,
             cityId: this.city.value,
             hasSymptoms: true,
             symptoms
           })
         }
      }
    }
  }
</script>

<style lang="scss" scoped>
.symptoms {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  &-left {
    width: 48%;
  }
  &-right {
    width: 48%;
  }
}

@media screen and (max-width: 767px) {
  .symptoms {
    flex-wrap: wrap;
    &-left {
      width: 100%;
    }
    &-right {
      width: 100%;
    }
  }
}
</style>